export function getKtData(data: any, key: string): string | undefined {
  return data?.[key] ?? data?.entries?.toArray()?.filter(e => e.key == key)?.[0]?.value;
}

export function getAllKtData(data: any): Record<string, string> {
  let mapEntries = data?.entries?.toArray()
  let res = {}
  for (let entry of mapEntries) {
    res[entry.key] = entry.value
  }
  return res
}

export function ktI18nFn(wrappedFn) {
  return (data, lfStorage, lfI81n) => wrappedFn(getAllKtData(data), lfStorage, lfI81n)
}
